import TableRow from '@tiptap/extension-table-row';

export interface TableExtendedOptions {
  HTMLAttributes: Record<string, any>;
}

export const TableRowExtended = TableRow.extend<TableExtendedOptions>({
  content: '(tableCell | tableHeader | tableCaption)*',
});
